//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import components from './components/index.js'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  props: {
    item: {
      type: Object,
      default: () => {
        options: []
      },
    },
    curIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ...components,
  },
  data() {
    return {
      imgGroup: ['image_single', 'image_multiple'],
      section: ['section'],
      list: ['radio', 'checkbox'],
      options: [
        'radio',
        'checkbox',
        'image_single',
        'image_multiple',
        'dropdown_single',
        'dropdown_multiple',
        'select_multiple',
        'blank_multiple',
        'sort',
      ],
      type: ""
    }
  },
  computed: {
    // 添加各种判断类型
    editableClass() {
      return []
    },
  },
  created() {
    this.type = this.item.type;
  },
}
